import { render, staticRenderFns } from "./BalanceView.vue?vue&type=template&id=582aac0e&scoped=true&"
import script from "./BalanceView.vue?vue&type=script&lang=ts&"
export * from "./BalanceView.vue?vue&type=script&lang=ts&"
import style0 from "./BalanceView.vue?vue&type=style&index=0&id=582aac0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582aac0e",
  null
  
)

export default component.exports